import { Authority } from 'ufinet-web-functions'
import { PATH_NEW_TICKET, PATH_NEW_TICKET_CORP, PATH_NEW_TICKET_FTTH } from './routerNameMap'

export const routerPermissionMap = new Map<string, Authority[]>([
	[PATH_NEW_TICKET, [Authority.gtiCorporateModuleWrite, Authority.gtiFtthModuleWrite]],
	[PATH_NEW_TICKET_CORP, [Authority.gtiCorporateModuleWrite]],
	[PATH_NEW_TICKET_FTTH, [Authority.gtiFtthModuleWrite]],
])
